import { render } from "./ProductsUpload.vue?vue&type=template&id=0c556ab0"
import script from "./ProductsUpload.vue?vue&type=script&lang=ts"
export * from "./ProductsUpload.vue?vue&type=script&lang=ts"
script.render = render

export default script